exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".UploadImage__surround___2F7hN {\n    background-color: #eee;\n    height: 60vw;\n    width: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-direction: column;\n}\n\n.UploadImage__imgSurround___k253K {\n    display: flow-root;\n}\n\n.UploadImage__changeImg___1cAMi {\n    position: absolute;\n    right: 1rem;\n    bottom: 1rem;\n}\n\n.UploadImage__changeImgFileSelector___1tmQM {\n    width: inherit!important;\n    height: inherit!important;\n    position: absolute;\n    z-index: 1!important;\n    left: 0;\n    right: 0;\n    top: 0;\n    bottom: 0;\n}\n\n.UploadImage__text___1Jjyf {\n    width: 80%;\n    text-align: center;\n}\n\n.UploadImage__uploadWrapper___3cIhr {\n    position: relative;\n    overflow: hidden;\n    display: inline-block;\n    padding: 1rem;\n    margin-top: 0.25rem;\n}\n\n.UploadImage__uploadWrapper___3cIhr input[type=file] {\n    font-size: 100px;\n    position: absolute;\n    left: 0;\n    top: 0;\n    opacity: 0;\n}\n\n.UploadImage__uploadButton___3pMpR {\n    background-color: white!important;\n}\n\n.UploadImage__progress___2pnQh {\n    max-width: 14rem;\n}\n\n.UploadImage__icon___3fH9v {\n    vertical-align: middle;\n    margin-right: 0.25rem;\n}\n", ""]);

// exports
exports.locals = {
	"surround": "UploadImage__surround___2F7hN",
	"imgSurround": "UploadImage__imgSurround___k253K",
	"changeImg": "UploadImage__changeImg___1cAMi",
	"changeImgFileSelector": "UploadImage__changeImgFileSelector___1tmQM",
	"text": "UploadImage__text___1Jjyf",
	"uploadWrapper": "UploadImage__uploadWrapper___3cIhr",
	"uploadButton": "UploadImage__uploadButton___3pMpR",
	"progress": "UploadImage__progress___2pnQh",
	"icon": "UploadImage__icon___3fH9v"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?modules=true&localIdentName=[name]__[local]___[hash:base64:5]!./src/components/UploadImage.icss
// module id = 1436
// module chunks = 0